<template>
  <div class="waitingProcessing common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索ID：</div>
          <div class="content">
            <el-input v-model="form.leadId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户单位：</div>
          <div class="content">
            <el-input v-model="form.unit" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动名称：</div>
          <div class="content">
            <el-input v-model="form.activityName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户姓名：</div>
          <div class="content">
            <el-input v-model="form.customerName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">联系电话：</div>
          <div class="content">
            <el-input v-model="form.phone" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索分类：</div>
          <div class="content">
            <el-select v-model="form.leadTypeCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">私海池：</div>
          <div class="content">
            <el-select
              v-model="form.poolId"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="poolLoading"
            >
              <el-option v-for="(item, index) in poolOptions" :key="index" :label="item.value" :value="item.key" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索状态：</div>
          <div class="content">
            <el-select v-model="form.poolStat" clearable placeholder="请选择">
              <el-option
                v-for="item in leadStatOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索上传时间：</div>
          <div class="content">
            <el-date-picker
              v-model="form.time"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索来源：</div>
          <div class="content">
            <el-select v-model="form.leadSourceCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadSourceOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? '收起搜索' : '高级搜索' }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addClueHandle" v-if="btnPermission.indexOf('新建') >= 0">新建线索</el-button>
      <el-button plain @click="batchShareHandle" v-if="btnPermission.indexOf('转移') >= 0">批量转移</el-button>
      <el-button plain @click="deleteHandle" v-if="btnPermission.indexOf('删除') >= 0">批量删除</el-button>
    </div>
    <commonTable ref="waitingProcessingTable" />
    <!-- 新建线索 -->
    <addClueDialog
      :add-clue-show="addClueShow"
      @dialogCloseHandle="addClueClose"
      @addSubmitHandle="addSubmitHandle"
    />
    <!-- 导入线索 -->
    <importClueDialog
      :import-clue-show="importClueShow"
      @dialogCloseHandle="importClueClose"
      @submitHandle="importClueSubHandle"
    />
    <!-- 转移线索 -->
    <shareClueDialog
      title="部门内部转移"
      label="选择被转移人"
      :share-clue-show="shareClueShow"
      :selected-pool-list="selectedPoolList"
      @dialogCloseHandle="shareClueClose"
      @submitHandle="shareClueSubHandle"
    />
    <!-- 合并线索 -->
    <mergingClueDialog
      :merging-clue-show="mergingClueShow"
      :lead-id="rowData.leadId"
      @dialogCloseHandle="mergingClueClose"
      @submitHandle="mergingSubHandle"
    />
    <!-- 关闭线索 -->
    <closeClueDialog
      :row-data="rowData"
      :close-clue-show="closeClueShow"
      @dialogCloseHandle="closeClueDialogClose"
      @closeClueSubHandle="closeClueSubHandle"
    />
    <!-- 渠道下单 -->
    <qdApplyOrderDialog
      :qd-apply-order-show="qdApplyOrderShow"
      :row-data="rowData"
      @dialogCloseHandle="qdApplyOrderClose"
      @submitHandle="qdOrderSubHandle"
    />
    <!-- 关联业务机会 -->
    <businessOppDialog
      :row-data="rowData"
      :business-opp-show="businessOppShow"
      @dialogCloseHandle="businessOppClose"
      @submitHandle="businessOppSubHandle"
    />
    <!-- 转外销 -->
    <tranExtSalesDialog
      :tran-ext-sales-show="tranExtSalesShow"
      :row-data="rowData"
      @dialogCloseHandle="tranExtSalesClose"
      @submitHandle="tranExtSalesSubHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addClueDialog from './component/waitingProcessing/addClueDialog';
import importClueDialog from '@/views/cluePool/component/cluePoolList/importClueDialog';
import shareClueDialog from '@/views/cluePool/component/cluePoolList/shareClueDialog';
import mergingClueDialog from './component/waitingProcessing/mergingClueDialog';
import closeClueDialog from './component/waitingProcessing/closeClueDialog';
import qdApplyOrderDialog from './component/waitingProcessing/qdApplyOrderDialog';
import businessOppDialog from './component/waitingProcessing/businessOppDialog';
import tranExtSalesDialog from './component/waitingProcessing/tranExtSalesDialog';
import { cluePoolListApi } from '../cluePool/service';
import { waitingProcessingApi } from './service';

export default {
  name: 'WaitingProcessing',
  data () {
    return {
      rowData: {},
      btnPermission: [],
      form: {
        poolType: '2',
        poolConfigType: 'privateSeaSelfFollow'
      },
      tempForm: {
        poolType: '2',
        poolConfigType: 'privateSeaSelfFollow'
      },
      leadTypeOptions: [],
      poolOptions: [],
      leadStatOptions: [],
      selectedPoolList: [],
      leadSourceOptions: [],
      poolLoading: false,
      addClueShow: false,
      importClueShow: false,
      shareClueShow: false,
      mergingClueShow: false,
      closeClueShow: false,
      qdApplyOrderShow: false,
      businessOppShow: false,
      tranExtSalesShow: false,
      searchOpenFlag: false
    };
  },
  components: {
    commonTable,
    addClueDialog,
    importClueDialog,
    shareClueDialog,
    mergingClueDialog,
    closeClueDialog,
    qdApplyOrderDialog,
    businessOppDialog,
    tranExtSalesDialog
  },
  methods: {
    deleteHandle (row) {
      let selectRow = this.$refs.waitingProcessingTable.getCheckboxRecords();
      if (!row.leadId && selectRow.length < 1) {
        this.$message.error('请选择要删除的线索');
        return;
      }
      let tipsText = '确定是否删除该线索';
      let params = [];
      if (!row.leadId) {
        tipsText = `确定删除${selectRow.length}条线索`;
        params = selectRow.map(item => {
          return item.leadId;
        });
      } else {
        params = [row.leadId];
      }
      this.$confirm(tipsText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.waitingProcessingTable.loading = true;
        cluePoolListApi.deleteLead(params).then(res => {
          if (res.status === '200') {
            this.searchBtn();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
          this.$refs.waitingProcessingTable.loading = false;
        });
      }).catch(() => {

      });
    },
    businessOppSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.relateBusinessOppo(data).then(res => {
        if (res.status === '200') {
          this.$message.success('关联成功');
          this.businessOppShow = false;
          this.searchBtn();
        }
      });
      this.$store.commit('setSubPageLoading', false);
    },
    importClueSubHandle () {
      this.importClueShow = false;
      this.searchBtn();
    },
    mergingSubHandle (params) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.leadMerge(params).then((res) => {
        if (res.status === '200') {
          this.$message.success('合并成功');
          this.mergingClueShow = false;
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    toInsalerHandle (row) {
      this.$confirm('是否转内销？', '转内销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        waitingProcessingApi.toInsaler([row.leadId]).then(res => {
          if (res.status === '200') {
            this.$message.success('操作成功');
            this.searchBtn();
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    shareClueSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.transfer(data).then(res => {
        if (res.status === '200') {
          this.$message.success('操作成功');
          this.searchBtn();
          this.shareClueShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    remoteMethod (query) {
      this.poolLoading = true;
      cluePoolListApi.getPoolOptionList(2, query).then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.poolOptions = res.data;
          } else {
            this.poolOptions = [];
          }
        }
        this.poolLoading = false;
      });
    },
    closeClueSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.leadClose(data).then((res) => {
        if (res.status === '200') {
          this.closeClueShow = false;
          this.$message.success('操作成功');
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addSubmitHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.addLead(data).then(res => {
        if (res.status === '200') {
          this.addClueShow = false;
          this.$message.success('添加成功');
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editJumpHandle (row) {
      this.$router.push({
        path: '/clueDetails',
        query: {
          leadId: row.leadId,
          metaActive: '/waitingProcessing',
          editFlag: 1
        }
      });
    },
    detailsJump (row) {
      this.$router.push({
        path: '/clueDetails',
        query: {
          leadId: row.leadId,
          metaActive: '/waitingProcessing'
        }
      });
    },
    tranExtSalesSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.toOutsaler(data).then(res => {
        if (res.status === '200') {
          this.$message.success('操作成功');
          this.searchBtn();
          this.tranExtSalesShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    tranExtSalesHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.tranExtSalesShow = true;
    },
    tranExtSalesClose () {
      this.tranExtSalesShow = false;
    },
    businessOppHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.businessOppShow = true;
    },
    businessOppClose () {
      this.businessOppShow = false;
    },
    qdOrderSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      waitingProcessingApi.qdOrder(data).then(res => {
        if (res.status === '200') {
          this.$message.success('下单成功');
          this.searchBtn();
          this.qdApplyOrderShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    qdApplyOrderHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.qdApplyOrderShow = true;
    },
    qdApplyOrderClose () {
      this.qdApplyOrderShow = false;
    },
    shareClueHandle (row) {
      this.selectedPoolList = [row];
      this.shareClueShow = true;
    },
    closeClueHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.closeClueShow = true;
    },
    closeClueDialogClose () {
      this.closeClueShow = false;
    },
    setStateHandle (row) {
      this.$confirm('是否将线索状态变更为‘已申请新建客户’？', '状态变更', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        waitingProcessingApi.customerCreated(row.leadId).then(res => {
          if (res.status === '200') {
            this.$message.success('操作成功');
            this.searchBtn();
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    suspendHandle (row) {
      this.$confirm('是否挂起该条线索？', '挂起线索', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        waitingProcessingApi.hang(row.leadId).then(res => {
          if (res.status === '200') {
            this.$message.success('操作成功');
            this.searchBtn();
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    mergingClueHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.mergingClueShow = true;
    },
    mergingClueClose () {
      this.mergingClueShow = false;
    },
    batchShareHandle () {
      let selectRowObj = this.$refs.waitingProcessingTable.getCheckboxRecords();
      if (selectRowObj.length > 0) {
        this.selectedPoolList = selectRowObj;
        this.shareClueShow = true;
      } else {
        this.$message.error('请选择需要转移的线索');
      }
    },
    leadHandle (event, row) {
      event.method(row);
    },
    shareClueClose () {
      this.shareClueShow = false;
    },
    importHandle () {
      this.importClueShow = true;
    },
    importClueClose () {
      this.importClueShow = false;
    },
    addClueHandle () {
      this.addClueShow = true;
    },
    addClueClose () {
      this.addClueShow = false;
    },
    reset () {
      this.form = {
        poolType: '2',
        poolConfigType: 'privateSeaSelfFollow'
      };
      this.searchBtn();
    },
    searchBtn () {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      if (this.tempForm.time) {
        this.tempForm.startTime = this.form.time[0].format('yyyy-MM-dd');
        this.tempForm.endTime = this.form.time[1].format('yyyy-MM-dd');
        delete this.tempForm.time;
      }
      if (this.tempForm.time === null) {
        delete this.tempForm.time;
      }
      this.$refs.waitingProcessingTable.pageData.pageNum = 1;
      // this.$refs.waitingProcessingTable.getTableData({ url: '/lead/lead/list/condition', params: this.tempForm });
      this.loadTable(this.tempForm);
    },
    loadTable (requerParams) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('50')
          ._others('checkbox')
          ._fixed('left')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索ID')
          ._width('120')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{ row.leadId }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('客户单位')
          ._width('8%')
          ._data('unit')
      );
      tableRow.push(
        new TableColumns()
          ._title('联系电话')
          ._width('9%')
          ._data('phone')
      );
      tableRow.push(
        new TableColumns()
          ._title('客户名称')
          ._width('8%')
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._title('城市')
          ._width('6%')
          ._data('city')
      );
      tableRow.push(
        new TableColumns()
          ._title('行业')
          ._width('6%')
          ._data('industry')
      );
      tableRow.push(
        new TableColumns()
          ._title('产品线')
          ._width('8%')
          ._data('productLine')
          ._offOverFlow(true)
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('线索分类')
      //     ._width('8%')
      //     ._data('leadTypeName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动编号')
      //     ._width('8%')
      //     ._data('activityCode')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动分类')
      //     ._width('8%')
      //     ._data('activityClassificationName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动名称')
      //     ._width('8%')
      //     ._data('activityName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('实际线索等级')
      //     ._width('8%')
      //     ._data('classificationActualName')
      // );
      tableRow.push(
        new TableColumns()
          ._title('线索上传日期')
          ._width('10%')
          ._data('uploadTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{date}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('备注')
          ._width('8%')
          ._data('remark')
          ._offOverFlow(true)
      );
      tableRow.push(
        new TableColumns()
          ._title('线索状态')
          ._width('8%')
          ._data('statName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('200')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let btnAll = [
                {
                  text: '转内销',
                  isShow: row.buttonVO.isInSaleShow,
                  method: this.toInsalerHandle
                },
                {
                  text: '编辑',
                  isShow: row.buttonVO.isEditShow,
                  method: this.editJumpHandle
                },
                {
                  text: '关闭',
                  isShow: row.buttonVO.isCloseShow,
                  method: this.closeClueHandle
                },
                {
                  text: '合并',
                  isShow: row.buttonVO.isMergeShow,
                  method: this.mergingClueHandle
                },
                {
                  text: '挂起',
                  isShow: row.buttonVO.isHangShow,
                  method: this.suspendHandle
                },
                {
                  text: '转移',
                  isShow: row.buttonVO.isTransferShow,
                  method: this.shareClueHandle
                },
                {
                  text: '已申请创建客户',
                  isShow: row.buttonVO.isNewCustomerShow,
                  method: this.setStateHandle
                },
                {
                  text: '渠道下单',
                  isShow: row.buttonVO.isQdOrderShow,
                  method: this.qdApplyOrderHandle
                },
                {
                  text: '关联业务机会',
                  isShow: row.buttonVO.isRelateBusinessOpportunityShow,
                  method: this.businessOppHandle
                },
                {
                  text: '转外销',
                  isShow: row.buttonVO.isOutSalerShow,
                  method: this.tranExtSalesHandle
                },
                {
                  text: '删除',
                  isShow: row.buttonVO.isDeleteShow,
                  method: this.deleteHandle
                }
              ];
              let btns = btnAll.filter(item => {
                return item.isShow;
              });
              return (
                <div>
                  {
                    btns[0] ? (
                      <el-button type="text" onClick={() => { btns[0].method(row); }}>{ btns[0].text }</el-button>
                    ) : null
                  }
                  {
                    btns[1] ? (
                      <el-button type="text" onClick={() => { btns[1].method(row); }}>{ btns[1].text }</el-button>
                    ) : null
                  }
                  {
                    btns.length > 2 ? (
                      <el-dropdown trigger="click" onCommand={($event) => {
                        this.leadHandle($event, row);
                      }}>
                        <span class="el-dropdown-link">
                          更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          {
                            btns.slice(2).map((item, index) => {
                              return (
                                <el-dropdown-item key={index} command={item}>{item.text}</el-dropdown-item>
                              );
                            })
                          }
                        </el-dropdown-menu>
                      </el-dropdown>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.waitingProcessingTable.setColumn(column, {
        checkboxReserve: true
      });
      this.$refs.waitingProcessingTable.loadTable({ url: '/lead/lead/list/condition', listKey: 'list', params: requerParams || this.form });
    },
    btnShow (btnName, stateCode) {
      /* 待处理-6
      待处理-6
      线索可能重复-3
      非列名客户-11
      已申请新建客户-12 */
      switch (btnName) {
        case '合并':
          return this.btnPermission.indexOf('合并') >= 0 && stateCode === 3;
        case '编辑':
          return this.btnPermission.indexOf('编辑') >= 0 && stateCode !== 12;
        case '挂起':
          return this.btnPermission.indexOf('挂起') >= 0;
        case '关闭':
          return this.btnPermission.indexOf('关闭') >= 0;
        case '转移':
          return this.btnPermission.indexOf('转移') >= 0 && stateCode !== 2;
        case '已申请创建客户':
          return this.btnPermission.indexOf('已申请创建客户') >= 0;
        case '渠道下单':
          return this.btnPermission.indexOf('渠道下单') >= 0 && stateCode !== 2;
        case '关联业务机会':
          return this.btnPermission.indexOf('关联业务机会') >= 0 && (stateCode === 3 || stateCode === 6);
        case '转外销':
          return this.btnPermission.indexOf('转外销') >= 0 && (stateCode === 3 || stateCode === 12);
        case '转内销':
          return this.btnPermission.indexOf('转内销') >= 0 && (stateCode === 6 || stateCode === 3);
      }
    },
    getOptionsList () {
      cluePoolListApi.getOptionsList('PRIVATE_SEA_TODO').then(res => {
        if (res.status === '200') {
          this.leadTypeOptions = res.data.leadTypeOptions;
          this.leadStatOptions = res.data.leadStatOptions;
          this.leadSourceOptions = res.data.leadSourceOptions;
        }
      });
    }
  },
  activated () {
    this.$refs.waitingProcessingTable.getTableData({ url: '/lead/lead/list/condition', listKey: 'list', params: this.tempForm });
  },
  mounted () {
    let jurisdiction = this.$store.state.userInfo.permissionDTO.leadModule;
    // 按钮权限
    if (jurisdiction.lead_function) {
      this.btnPermission = jurisdiction.lead_function.lead_function_private_sea;
    }
    this.getOptionsList();
    this.loadTable();
    this.remoteMethod('');
  }
};
</script>

<style scoped>

</style>
